var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.667,
    height: 21.333,
    viewBox: "0 0 26.667 21.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M26,4H4.667A2.663,2.663,0,0,0,2.013,6.667L2,22.667a2.675,2.675,0,0,0,2.667,2.667H26a2.675,2.675,0,0,0,2.667-2.667v-16A2.675,2.675,0,0,0,26,4Zm0,18.667H4.667V9.333L15.333,16,26,9.333ZM15.333,13.333,4.667,6.667H26Z",
    transform: "translate(-2 -4)",
    fill: "#0b4475"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon_mail.659213ff3d4670d2b3a9dd45b68e82dd.svg";
export { ForwardRef as ReactComponent };